import { useState, useEffect } from 'react';
import { toggleIsArchived } from '../../../util/util';
import Modal from './Modal';
import ModalActions from './ModalActions';
import { useToast } from '../../ui/Toast';

function ShowHideModal({ isModalOpen, setIsModalOpen, selectedShow, onShowHidden }) {
  const { showSuccess, showError } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const isHidden = !!selectedShow?.is_archived;

  useEffect(() => {
    setIsLoading(false);
  }, [isModalOpen]);

  const unhideShow = async showId => {
    await toggleIsArchived(showId, true);
    onShowHidden?.(showId, false);
    showSuccess('Show unhidden.');
  };

  const handleToggleHide = async () => {
    if (!selectedShow) return;
    const { show_id: showId, show_title: showTitle } = selectedShow;
    setIsLoading(true);
    try {
      if (isHidden) {
        await unhideShow(showId);
      } else {
        await toggleIsArchived(showId, false);
        onShowHidden?.(showId, true);
        showSuccess(`"${showTitle}" hidden.`, {
          action: {
            label: 'Undo',
            onClick: () =>
              unhideShow(showId).catch(error => {
                console.error('Error undoing hide:', error);
                showError(`Failed to unhide show: ${error.message}`);
              }),
          },
        });
      }
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error hiding show:', error);
      showError(`Failed to ${isHidden ? 'unhide' : 'hide'} show: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => !isLoading && setIsModalOpen(false)}
      title={`${isHidden ? 'Unhide' : 'Hide'} "${selectedShow?.show_title}"?`}
      maxWidth="max-w-md"
    >
      <p className="text-sm text-slate-400">
        {isHidden
          ? 'This show will become visible again in the feed and search.'
          : 'This show will be hidden from the feed and search, but will still count in your analytics. You can unhide it anytime from the Hidden Shows list in the Manage tab.'}
      </p>

      <ModalActions
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleToggleHide}
        confirmLabel={isHidden ? 'Unhide' : 'Hide'}
        confirmClassName={isHidden ? 'btn-primary w-28' : 'btn-error btn-outline w-28'}
        isLoading={isLoading}
      />
    </Modal>
  );
}

export default ShowHideModal;
